import { render, staticRenderFns } from "./InstitutionalUsers.vue?vue&type=template&id=113a5883"
import script from "./InstitutionalUsers.vue?vue&type=script&lang=js"
export * from "./InstitutionalUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports